import { takeLatest, fork, call, all, put } from "redux-saga/effects";
import { STATEMENT_ACTIONS } from "constants/actions";
import { StatementRecord } from "records/statement-record";
import StatementService from "services/statement-service";
import {
    createdStatement,
    fetchedStatement,
    failedFetchStatement,
    failedDeleteStatement,
    deletedStatement,
    updatedStatement,
    failedUpdateStatement,
    fetchStatement
} from "../actions";
import { message } from "antd";

function* createStatement({ payload: { caseId, bankAccountId, options } }) {
    const month_year = options.month_year;
    const values = yield all(
        (options.num_months === 6 ? [1, 2, 3, 4, 5, 6] : [1, 2, 3]).map(() => {
            const formattedMonth = month_year.format("YYYY-MM-DD");
            month_year.subtract(1, "month");
            return call(
                StatementService.create,
                caseId,
                new StatementRecord({
                    case: caseId,
                    case_bank_account: bankAccountId,
                    txn_month_year: formattedMonth
                })
            );
        })
    );

    if (values.reduce((agg, _) => !_.err && agg, true)) {
        yield put(createdStatement(caseId, bankAccountId));
        yield put (fetchStatement(
            caseId,
            bankAccountId
        ));
    }
}

function* deleteStatement({ payload: { caseId, bankAccountId } }) {
    try {
        yield call(StatementService.in_active_previous, caseId, bankAccountId);
        yield put(deletedStatement(caseId, bankAccountId));
    } catch (error) {
        message.error("Failed to Delete Statement");
        failedDeleteStatement(error);
    }
}

function* fetchStatementHandler({ payload: { caseId, bankAccountId } }) {
    const { data, error } = yield call(
        StatementService.fetchStatement,
        caseId,
        bankAccountId
    );
    if (!error) {
        yield put(fetchedStatement(caseId, bankAccountId, data));
    } else {
        yield put(failedFetchStatement(caseId, bankAccountId, error));
    }
}

function* updateStatement({ payload: { caseId, bankAccountId, statement } }) {
    const { error } = yield all(
        statement
            .toList()
            .map(_ => call(StatementService.updateStatement, caseId, _.id, _))
            .toArray()
    );
    if (!error) {
        yield put(updatedStatement(caseId, bankAccountId, statement));
    } else {
        message.error("Failed to Update Statement");
        yield put(failedUpdateStatement(caseId, bankAccountId, error));
    }
}

export default fork(function*() {
    yield takeLatest(STATEMENT_ACTIONS.CREATE_STATEMENT, createStatement);
    yield takeLatest(STATEMENT_ACTIONS.FETCH_STATEMENT, fetchStatementHandler);
    yield takeLatest(STATEMENT_ACTIONS.UPDATE_STATEMENT, updateStatement);
    yield takeLatest(STATEMENT_ACTIONS.DELETE_STATEMENT, deleteStatement);
});
